import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAdmin } from "@/admin/AdminContext";
import { PageHeader, StatusPill, EmptyState } from "@/admin/ui";
import { money } from "@/lib/brand";
import { CreditCard } from "lucide-react";

export default function Payments() {
  const { version } = useAdmin();
  const [payments, setPayments] = useState([]);

  useEffect(() => { api.get("/payments").then((r) => setPayments(r.data)).catch(() => {}); }, [version]);

  return (
    <div className="animate-fade-up">
      <PageHeader title="Payments" subtitle="All transactions and payment requests" />
      {payments.length === 0 ? (
        <EmptyState icon={CreditCard} title="No payments yet" hint="Payments appear here once clients pay." />
      ) : (
        <div className="bg-white border border-[#E2EBF0] rounded-xl overflow-hidden" data-testid="payments-list">
          <div className="hidden sm:grid grid-cols-5 gap-2 px-4 py-2.5 bg-[#F4FFF9] text-xs font-mono uppercase tracking-wide text-[#4A635A]">
            <span>Client</span><span>Service</span><span>Type</span><span className="text-right">Amount</span><span className="text-right">Status</span>
          </div>
          {payments.map((p, i) => (
            <div key={p.session_id || p.stripe_invoice_id || i} data-testid={`payment-row-${i}`}
              className="grid grid-cols-2 sm:grid-cols-5 gap-2 px-4 py-3 border-b border-[#E2EBF0] last:border-0 items-center text-sm">
              <span className="text-[#0D3B2D] truncate">{p.client_name}</span>
              <span className="text-[#4A635A] truncate">{p.service_name}</span>
              <span className="text-[#4A635A] capitalize hidden sm:block">{(p.payment_type || "").replace("_", "-")}</span>
              <span className="font-mono text-[#0D3B2D] text-right">{money(p.amount)}</span>
              <span className="text-right"><StatusPill status={p.payment_status} /></span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
